import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent, HeaderComponent, LayoutService, NavComponent, NavigationItem } from '@cvx/nextpage';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, FooterComponent, NgbModule, NavComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    encapsulation: ViewEncapsulation.None, // So that we can apply styles to the NextPage components
})
export class AppComponent implements OnInit {
    protected navigationItems: NavigationItem[] = [
        {
            label: 'Business Domains',
            link: '/business-domains',
        },
        {
            label: 'Connections',
            link: '/connections',
        },
        {
            label: 'Datasets',
            link: '/datasets',
        },
        {
            label: 'Help',
            link: '/help',
        },
    ];
    public constructor(private readonly layoutService: LayoutService) {}
    public ngOnInit(): void {
        this.layoutService.setClass('layout-12');
    }
}
